/* eslint-disable @typescript-eslint/no-explicit-any */

import { Injectable } from '@angular/core';
import * as moment from 'moment';
import 'moment/locale/it';
import {EnumObj} from 'src/app/models/shared.models';
import { AppConstants } from '../classes/app-costants';

@Injectable()
export class UtilsService {
  /**
   * @description Ordinamento generico di un array di oggetti per una proprietà
   *
   * @param toSort
   * @param prop
   * @param sortType
   */
  public static sortArray<T>(toSort: Array<T>, prop: keyof T, sortType: 'ASC' | 'DESC'): Array<T> {
    toSort.sort((left, right): number => {
      if (left[prop] < right[prop])
        return -1;
      if (left[prop] > right[prop])
        return 1;

      return 0;
    });

    if (sortType === 'DESC')
      return toSort.reverse();

    return toSort;
  }

  /**
    * @description Converte una enum in un array di oggetti
    * @param e
    */
  public static enumToArray<T>(e: T): Array<EnumObj> {
    const resultArray: Array<EnumObj> = new Array<EnumObj>();

    for (const item in e) {
        if (typeof (e[item]) === 'number') {
            resultArray.push(new EnumObj({ Id: <any>e[item], Name: item }));
        }
    }

    return resultArray;
  }

  /**
   * @description Generazione di una stringa random
   * @param length
   */
  public static generateRandomString(length: number): string {
    let str = '';
    const charSet = Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxys0123456789!@£$%&()=');

    for (let i = 0; i < charSet.length; i++) {
      if (str.length === length) {
        break;
      }

      const randomNumber = this.generateRandomNumber(0, charSet.length - 1);
      str += charSet[randomNumber];
    }

    return str;
  }

  /**
   * @description Generazione di un numero random in un range
   * @param min
   * @param max
   * @returns
   */
  public static generateRandomNumber(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);

    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  public static ConvertDateToTimeZoneIta(dateToConvert : Date): Date {
    return new Date(moment(dateToConvert.toISOString()).locale('it').format('YYYY-MM-DD'));
  }

  public static ConvertDateToTimeZoneItaAndHour(dateToConvert : Date): Date {
    return new Date(moment(dateToConvert.toISOString()).locale('it').format('YYYY-MM-DD HH:mm'));
  }
  public static SetHourTO_DATE(date : Date):Date{
    date.setHours(12);
    return date;
  }
  public static ConvertTo_DATE_DATABASE_FORMAT(dateToConvert : string):Date{
    moment.locale('it');
    const date = moment(dateToConvert, 'DD/MM/YYYY').toDate();
    date.setHours(12);
    return date;
  }

  public static ConvertTo_DATEMONTH_DATABASE_FORMAT(dateToConvert : string):Date{
    moment.locale('it');
    return moment(dateToConvert, 'MM/YYYY').toDate();
  }

}
